<template>
    <div v-loading="mixinLoading">
        <Query ref="query" :page="pageName" @query-click="handleQueryClick" :list="allFilterList"/>
        <!-- 自定义列 -->
        <CustomizeModal
        ref="refcustomizeModal"
        :customList="assignObj"
        :selectList="selectList"
        :customBtnLoading="customBtnLoading"
        @getCustomList="getCustomList"/>
        <div class="com-table-view-apple">
            <div class="operation-box" id="operation-box">
                <div class="operation-left">
                    <el-button type="primary" size="mini" v-if="pageFuncNames.includes('add_negative_keyword')" :loading="addLoading" @click="handleClickAdd">Add negative keyword</el-button>
                    <el-divider direction="vertical" v-if="pageFuncNames.includes('add_negative_keyword')"></el-divider>

                    <el-menu
                        v-if="isHasBatchAuth"
                        class="apple-cascader"
                        mode="horizontal"
                        @select="(val)=>handleCommand(val, '')">
                        <el-submenu index="1" :popper-append-to-body="false">
                            <template slot="title"><span>Batch Edit</span></template>
                            <el-menu-item :disabled="isEmptySelection" v-if="!isHasAuth('copy_negative_keyword')" index="3"><span style="color: #333;">Copy</span></el-menu-item>
                            <el-menu-item class="err-menu-item" index="5" v-if="!isHasAuth('del')" :disabled="isEmptySelection"><span style="color: #ff0000;">Delete</span></el-menu-item>
                        </el-submenu>
                    </el-menu>
                    <span v-if="multipleSelection.length>0" style="padding-left: 8px;">{{multipleSelection.length}} Items Selected</span>

                </div>
                <div class="operation-right">
                    <el-button
                        icon="el-icon-s-operation"
                        size="mini"
                        @click="handleShowDefineRow">Custom Columns</el-button>
                    <el-button
                        icon="el-icon-download"
                        size="mini"
                        v-if="!isHasAuth('export')"
                        :loading="exportLoading"
                        @click="handleExport">Export</el-button>
                </div>
            </div>

            <div style="min-height: 200px;">
                <el-table
                    :data="tableData"
                    style="width: 100%;"
                    ref="multipleTable"
                    :row-key="getRowKey"
                    :header-cell-style="{background:'#e8eaec',color:'#333'}"
                    @selection-change="handleSelectionChange"
                    @sort-change="handlesortchange"
                    v-loading="!mixinLoading && loading"
                    header-row-class-name="jt_sticky"
                >
                    <!--复选框）-->
                    <el-table-column
                        type="selection"
                        width="50"
                        align="center"
                        fixed="left"
                        :selectable="selectable"
                        >
                    </el-table-column>

                    <!-- 默认 -->
                    <el-table-column
                        :prop="column.name"
                        :label="column.display_name"
                        :align="column.align"
                        :min-width="column.width"
                        :fixed="column.fixed !='' ? column.fixed : false"
                        :sortable="getsortable(column['field_type'], column.name)"
                        v-for="(column, index) in columns"
                        :key="index"
                        :render-header="(h, values)=>renderHeader(h, values, column)"
                        >
                        <template slot-scope="scope">
                            <div class="table_operate" v-if="column.field_type=='1' && column.name=='operate'">
                                <!-- <span  @click="handledrawer(scope.$index)" style="color: #ff0000;">Delete</span> -->
                                <el-button type="text" :disabled="isHasAuth('del') || scope.row['delbtn_status_disabled']" @click="handleDel(scope.$index, 'del')" :style="{color: (!isHasAuth('del') && !scope.row['delbtn_status_disabled']) ? '#ff0000' : 'f3f3f3'}">Delete</el-button>
                            </div>

                            <div v-else-if="column.field_type=='1' && column.name=='plan_name_start_date'">
                                <p>{{scope.row['start_time']}}</p>
                                <p>{{scope.row['end_time']}}</p>
                            </div>

                            <div v-else-if="column.field_type=='1' && column.name=='key_word_text'">
                                <span v-if="scope.row.match_type=='精准匹配'||scope.row.match_type=='Exact Match'">[{{scope.row.key_word_text}}]</span>
                                <span v-else>{{scope.row.key_word_text}}</span>
                            </div>

                            <div v-else-if="column.field_type=='2'">
                                <div class="currency_flex" v-if="getcurrency(scope.row, column.name)['has']">
                                    <div class="column_name">
                                        {{ getcurrency(scope.row, column.name)['name'] }}
                                    </div>
                                    <div class="column_currency">
                                        {{ getcurrency(scope.row, column.name)['currency'] }}
                                    </div>

                                </div>
                                <div class="currency_flex" v-else> {{ getcurrency(scope.row, column.name)['name'] }}</div>
                            </div>

                            <div class="lineheightmax" v-else>{{scope.row[column.name]}}</div>

                        </template>
                    </el-table-column>

                </el-table>
            </div>

            <div class="component_pagination">
                <el-pagination
                    v-if="pagination"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :current-page="pn"
                    :page-sizes="[30, 50, 100]"
                    :page-size="rn"
                    :pager-count="5"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="totalCnt">
                </el-pagination>

            </div>

            <el-dialog
                :title="null"
                :visible.sync="dialogVisible"
                :close-on-click-modal=false
                :close-on-press-escape=false
                :show-close=false
                :destroy-on-close=true
                width="450px"
                custom-class="apple-dialog-err">
                <div>
                    <h5 class="tac font16px">{{dialogTypeTitle}}</h5>
                    <p class="tac text-color-error pt10 pb20">Please do not refresh the page, refreshing the page may result in not receiving the latest results in time.</p>
                </div>
            </el-dialog>

            <BatchBudgetModal ref="batchBudgetModal" :list="multipleSelection" @update="getListBody(props_params)"/>
            <NegativeKeywordModal ref="negativeKeywordModal" :action-rows="actionRows" :form-data="actionRowData" :action-type="actionType" @update="getListBody(props_params)"/>
            <el-tooltip ref="cellTip" v-model="showPopper" placement="top-start" effect="dark">
                <div class="tip-apple-content" slot="content">{{tipContent}}</div>
            </el-tooltip>
        </div>
    </div>
</template>

<script>
    import {mapGetters} from 'vuex';
    import Query from "../../components/query.vue";
    import CustomizeModal from '../../modal/customizeModal';
    import API from '@/api/marketManage/apple/index-en';
    import BatchBudgetModal from '../../campaign/modal/batchBudgetModal';
    import NegativeKeywordModal from '../modal/negativeKeywordModal';
    import { cloneDeep, debounce } from 'lodash'
    import utils from '@/libs/utils.js';
    import {
        handleDocumentNoctiyClick,
        get_err_info,
        get_flag_single_post_html,
        get_flag_suc_html,
        get_flag_single_err_html,
        get_flag_mul_err_html,
    } from "../../components/getFlagHtml.js";
    const other_Table_columns_no_sort = ['plan_name_start_date', 'creation_time']
    export default {
        name: "NegativeKeywordPage",
        props:{
            pageDimension:Array,
            pageFields:Array,
            pageFunc:Array,
            zone:String,
            rangeTime:Array,
            mixinLoading:Boolean,
            pageActionNames:Array,
        },
        components: {
            Query,
            CustomizeModal,
            BatchBudgetModal,
            NegativeKeywordModal,
        },
        data() {
            return {
                pageName:'apple_promotion_manage_negative_keyword',
                value:true,
                props_params: {}, //query 组件吐出参数 对象形式  (一般用在勾选操作与导出)
                btnloading: false,  //每日预算按钮loading
                active: -1, // 每日预算点击
                drawer: false, //抽屉
                pagination: true,
                pn: 1,
                rn: 30,
                totalCnt:0,
                selectList: [],
                multipleSelection: [],
                columns: [],
                tableData:[],
                customBtnLoading: false, //自定义列按钮loading
                activeIndex: -1, //选中的详情条数
                cacha_money: '',  //缓存每日预算
                cacha_name: '', //缓存广告系列名称
                infoValue: false, // 详情开关
                infoactive: false, // 详情广告名称 显示输入与否
                infoysactive: false, //详情每日预算  显示与否
                infoName: '', // 广告系列名称
                show: false, //处理表格头显示后 显示表格
                loading: false, //处理表格loading
                options: [
                    {
                        value: '1',
                        label: 'Switch - Run',
                        children: [
                            {
                                value: 'all',
                                label: 'Select All',
                            }
                        ]
                    },
                    {
                        value: '2',
                        label: 'Switch - Pause',
                    },
                    {
                        value: '3',
                        label: 'Copy',
                    },
                    {
                        value: '4',
                        label: 'Daily Budget',
                    },
                    {
                        value: '5',
                        label: 'Delete',
                    }
                ],
                delloading: false,  //删除按钮loading
                dialogVisible: false,   //各种错误提示
                dialogBoo: true,   // 是否失败
                dialogType: 1,   //1单个处理 2多个处理
                dialogTypeTitle: 'request successful, processing…', //显示提示头
                dialogTypeBody: '1000027869，Processing, please wait', //显示提示头
                mulerrIds: '',
                mulErr:'',
                mulexc: '',
                cachaHeader: 1,
                abc: '',
                bca: '',
                actionType:'',      // 记录关键词弹窗的 添加/复制
                showPopper: false, //浮层提醒
                tipContent: '',    //浮层提醒内容
                exportLoading:false,
                addLoading:false,
            }
        },
        computed:{
            ...mapGetters(['tabs_map', 'apple_reload','apple_list_page_query']),
            allFilterList(){
                let dimensions = cloneDeep(this.pageDimension)
                /* 需要过滤掉[操作]列 */
                return dimensions.filter(item=>item.config&&item.name!='operate').map(item=>{
                    item.config = JSON.parse(item.config);
                    return item;
                })
            },
            assignObj() {
                let chone_list = cloneDeep(this.pageDimension)
                let chone_list_pageFields = cloneDeep(this.pageFields)
                let res_dime = chone_list.map(item=>{
                    item['meconfig'] = item['config'] && JSON.parse(item.config);
                    return item;
                })
                let res_pageFields = chone_list_pageFields.map(item=>{
                    // item.config = item['config'] && JSON.parse(item.config);
                    if(item['children']) {
                        item['children'].map(itemc => {
                            itemc['meconfig'] = itemc['config'] && JSON.parse(itemc['config']);
                            return itemc
                        })
                    }
                    return item;
                })
                let baselist = {
                    id : "b_1000",
                    name: 'base',
                    display_name: 'Basic Information',
                    children: res_dime
                }
                return [baselist,...res_pageFields]
            },
            getappledialogerr() {
                if(this.mulErr != '' && this.mulexc != '') {
                    return 1
                }else if(this.mulErr != '' || this.mulexc != ''){
                    return 2
                }else{
                    return 3
                }
            },
            pageFuncNames(){
                return (this.pageFunc||[]).map(item=>item.name);
            },
            isEmptySelection(){
                return this.multipleSelection.length<=0;
            },
            actionRows(){
                return this.multipleSelection.map(item=>item);
            },
            actionRowData(){
                let orgIds = this.actionRows.map(item=>item.org_id).filter(item=>!!item);
                let campaignIds = this.actionRows.map(item=>item.campaign_id).filter(item=>!!item);
                let adGroupIds = this.actionRows.map(item=>item.adgroup_id).filter(item=>!!item);
                let row = this.actionRows[0]||{};
                let data = {};

                /* 判断是否需要设置默认值 */
                if(orgIds.every(item=>item===row.org_id)){
                    data.org_id = row.org_id;
                    data.org_name = row.org_name;
                }
                if(campaignIds.every(item=>item===row.campaign_id)){
                    data.campaign_id = row.campaign_id;
                    data.campaign_name = row.campaign_name;
                }
                if(adGroupIds.every(item=>item===row.adgroup_id)){
                    data.adgroup_id = row.adgroup_id;
                    data.adgroup_name = row.adgroup_name;
                }
                return data;
            },
            isHasBatchAuth(){
                let funcNames = this.pageFuncNames||[];
                return funcNames.includes('copy_negative_keyword')||funcNames.includes('del');
            },
        },
        watch: {
            apple_reload: function(val) {
                this.getListBody(this.props_params)
            }
        },
        mounted() {
            this.getEventTip()

            this.getListHead((res)=>{
                const fields = res && res.map(item=>item['name'])
                this.props_params['fields'] = []
                this.props_params['fields'] = fields
            })
        },
        beforeDestroy() {
        },
        methods:{
            getcurrency(rows, name) {
                let name_currency = `${name}_currency`
                if(rows[name_currency]) {
                    return {
                        has: true,
                        name: rows[name],
                        currency: rows[name_currency],
                    }
                }else{
                    return {
                        has: false,
                        name: rows[name]
                    }
                }
            },
            // query 查询  isClear为true：表示点击的是【清空筛选】
            handleQueryClick(params,isClear) {
                console.log('params', params)
                this.$refs.query.setSubmitLoading(true);
                if(isClear){
                    this.$refs.query.setClearLoading(true);
                }
                let range_time = Array.isArray(this.rangeTime) && this.rangeTime.length != 0 ? `${this.rangeTime[0]}/${this.rangeTime[1]}` : ''
                // this.props_params = {...params, range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn}
                this.pn = 1
                this.props_params = Object.assign(this.props_params,params,{range_time: range_time, time_zone: this.zone, pn: this.pn, rn: this.rn})
                // if(this.cachaHeader == 1) {
                //     this.getListHead((res)=>{
                //         const fields = res && res.map(item=>item['name'])
                //         this.props_params['fields'] = []
                //         this.props_params['fields'] = fields
                //         this.getListBody(this.props_params,isClear)
                //     })
                // }else{
                //     this.getListBody(this.props_params,isClear)
                // }
                this.getListBody(this.props_params,isClear)
            },
            getRowKey(row) {
                return row['keyword_id']
            },
            getShowInfoItem(arr, name) {
                if(Array.isArray(arr) && arr.length != 0) {
                    let isshow = arr.some(item=>item['name'] == name)
                    return true
                }else{
                    return false
                }
            },
            // 判断是否显示tip事件
            getEventTip() {
                const _this = this;
                const cellTip = this.$refs.cellTip;
                const delay = 200;

                // 超长提示事件
                $(this.$el).on('mouseenter.tdcell', '.lineheightmax', debounce(function() {

                    const $cell = $(this);
                    if ($cell[0].offsetHeight === $cell[0].scrollHeight) {
                        return;
                    }

                    cellTip.referenceElm = $cell[0];
                    _this.showPopper = true;
                    _this.tipContent = $cell.text();
                }, delay))
                .on('mouseleave.tdcell', '.lineheightmax', function() {
                    if (!_this.showPopper) {
                        return;
                    }

                    _this.showPopper = false;
                    setTimeout(() => {
                        _this.showPopper = false;
                    }, delay);
                });
            },
            getshowTip(name) {
                // campaign_name 广告系列 countries_or_regions 国家跟地区 campaign_display_status 状态 company_name  客户 org_name广告系列组 app_info 产品 bloc_name集团
                const showTip = ['key_word_text', 'search_term_text', 'adgroup_name','org_name','countries_or_regions', 'campaign_display_status', 'company_name', 'app_info', 'bloc_name']
                if(showTip.includes(name)) {
                    return true
                }else{
                    return false
                }
            },
            // 获取权限
            isHasAuth(name){
                let isauth = this.pageFunc.some(item => item['name'] == name)
                return !isauth
            },
            // 获取列表头
            getListHead(callback) {
                this.$refs.query.setSubmitLoading(true);
                this.loading = true
                this.columns.length = 0
                API.getCustomField({field_type: 'apple_promotion_manage_negative_keyword'}).then(res => {
                    let resData = res.data || []
                    this.selectList = resData
                    const width140 = ['keyword_id', 'campaign_id', 'org_id', 'account_name_start_date', 'adgroup_id', 'keyword_display_status', 'creation_time']
                    const width110 = ['account_yy_type', 'yy_name', 'keyword_status', 'supply_source', 'match_type', 'level_type']
                    this.columns = resData.map(item=>{
                        item["display_name"] = item.label
                        item['align'] = 'left'
                        // 宽度特殊处理
                        if(item['field_type'] == 2) {
                            item['align'] = 'right'
                            let nums = (item['display_name']||'').length
                            // item['width'] = item.name=='imp_price'?250:((nums * 12)) + 60
                            if(item.name=='imp_price' || item.name == 'local_spend') {
                                item['width'] = 250
                            }else {
                                item['width'] = ((nums * 12)) + 60
                            }
                        }else{
                            if(width140.includes(item.name)) {
                                item['width'] = 120
                            }else if(width110.includes(item.name)){
                                item['width'] = 90
                            }else{
                                item['width'] = 190
                            }
                        }
                        if(item.name == 'keyword_status') {
                            item['align'] = 'center'
                        }
                        return item
                    })
                    // this.columns = resData.map(item=>{
                    //     item["display_name"] = item.label
                    //     item['align'] = 'left'
                    //     // 宽度特殊处理
                    //     if(item['field_type'] == 2) {
                    //         if((item['display_name']||'').length >= 8) {
                    //             item['width'] = ((6 * 20) + 30)
                    //         }
                    //     }else{
                    //         if(item.name == 'daily_budget') {
                    //             item['width'] = 180
                    //         }else if(item.name == 'campaign_name') {
                    //             item['width'] = 130
                    //         }else if(item.name == 'start_end_time') {
                    //             item['width'] = 160
                    //         }else if(item.name == 'countries_or_regions') {
                    //             item['width'] = 140
                    //         }else if(item.name == 'operate') {
                    //             item['width'] = 80
                    //         }else{
                    //             item['width'] = 120
                    //         }
                    //     }
                    //     return item
                    // })
                    // this.show = true
                    // this.cachaHeader = 2
                    callback && callback(resData)
                }, err=>{
                    this.loading = false
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info)
                })
            },
            setListQueryData(){
                let queryData = {
                    org_id:this.props_params.org_id||[],
                    org_name:this.props_params.org_name||[],
                    campaign_id:this.props_params.campaign_id||[],
                    campaign_name:this.props_params.campaign_name||[],
                    adgroup_id:this.props_params.adgroup_id||[],
                    adgroup_name:this.props_params.adgroup_name||[],
                };

                this.$store.commit('apple/SET_LIST_PAGE_QUERY',queryData);
            },
            //  获取列表体
            getListBody(params,isClear) {
                    this.loading = true
                    this.$refs.query.setSubmitLoading(true);
                    if(isClear){
                        this.$refs.query.setClearLoading(true);
                    }
                    this.setListQueryData();
                    API.getNegativeKeywordList(params).then(res => {
                        this.loading = false
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                        let resData = res.data
                        let table_list = resData.list && resData.list.map(item=>{
                            item['delbtn_status_disabled'] = false  // 删除按钮 disabled  默认关
                            return item
                        })
                        this.tableData = table_list
                        // this.pn = resData.pageNum
                        this.totalCnt = resData.totalCnt
                    }, err=>{
                        if(err.code =='403'){
                            this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                                cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                    this.loading = false
                                });
                            return
                        }
                        this.loading = false
                        this.$message.error(err.info)
                        this.$refs.query.setSubmitLoading(false);
                        if(isClear){
                            this.$refs.query.setClearLoading(false);
                        }
                    })
            },
            // 获取状态颜色
            getStatusColor(val) {
                if(val == 'RUNNING') {
                    return 'text-color-success'
                }else if(val == 'ON_HOLD') {
                    return 'text-color-failed'
                }else{
                    return ''
                }
            },
            // 设置不可以选择
            selectable(row, index) {
                if(row['adgroup_display_status'] == 'DELETED') {
                    return false
                }else{
                    return true
                }
            },
            // 千分位处理
            formatNumberWithCommas(number) {
                // Check if the input is a valid number
                if (isNaN(number)) {
                    return "错误";
                }
                let formattedNumber = number.toLocaleString();

                if (formattedNumber.indexOf('.') !== -1) {
                    formattedNumber = parseFloat(number).toFixed(2);
                }
                return formattedNumber;
            },
            // 自定义列
            handleShowDefineRow () {
                this.$refs.refcustomizeModal.showModal();
            },
            // 获取自定义列
            getCustomList(values) {
                console.log('values', values)
                this.customBtnLoading = true
                API.setCustomField({
                    field_type: 'apple_promotion_manage_negative_keyword',
                    fields: values
                }).then(res => {
                    console.log('res', res)
                    this.customBtnLoading = false
                    this.$refs.refcustomizeModal.handleClose()
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                    this.getListHead((res)=>{
                        const fields = res && res.map(item=>item['name'])
                        this.props_params['fields'] = []
                        this.props_params['fields'] = fields

                        if(!fields.includes(this.props_params['order_by'])) {
                            this.props_params['order_by'] = ''
                            this.props_params['order_type'] = ''
                        }
                        this.getListBody(this.props_params)
                    })
                }, (err) => {
                    this.customBtnLoading = false
                    console.log('error', err);
                    if (err.code == '403') {
                        this.$confirm(err.info||'Request Error', 'Prompt', {
                            confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                            type: 'warning',
                            showClose: false,
                            closeOnClickModal: false,
                            closeOnPressEscape: false
                        }).then(() => {
                            window.location.reload()
                        }).catch(() => {
                        });
                        return
                    }
                    this.$message.error(err.info)

                })
            },
            // 多选
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },
            // 批量操作
            /**
             * 开 1  ENABLED
             * 关 2  PAUSED
             * 复制 3
             * 每日预算 4
             * 删除 5
             */
            handleCommand(el, index) {
                let selected_list_id = this.multipleSelection.map(item=>item.keyword_id)
                console.log(el, selected_list_id)
                // 复制
                if(el == 3) {
                    // API.editCampaignStatus({campaign_id: [], status: 'PAUSED'})
                    if(this.multipleSelection.length>0){
                        API.checkNegativeKeywordCopyNegativeKeyword().then(res=>{
                            this.actionType = 'negativeKeywordCopyNegativeKeyword';
                            this.$refs.negativeKeywordModal.showModal();
                        },err=>{
                            if (err.code == '403') {
                                this.$confirm(err.info||'Request Error', 'Prompt', {
                                    confirmButtonText: 'Refresh',
                                    cancelButtonText: 'Close',
                                    type: 'warning',
                                    showClose: false,
                                    closeOnClickModal: false,
                                    closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {
                                });
                                return
                            }
                            this.$message.error(err.info||'Request failed');
                        });
                    }
                }
                // 批量删除
                if(el == 5) {
                    this.$confirm('Are you sure you want to delete? Deleted items cannot be recovered.！', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                        }).then(() => {
                            if(selected_list_id.length == 1) {
                                let selectIndex = this.tableData.findIndex((element) => element['keyword_id'] == selected_list_id[0])
                                this.fetchdel('del', this.tableData[selectIndex]['keyword_id'], selectIndex)
                                return
                            }
                            this.fetchdelmul('del', selected_list_id)
                        }).catch(() => {
                            // this.$message({
                            //     type: 'info',
                            //     message: '已取消删除'
                            // });
                    });

                }
            },
            handleDel(index) {
                this.$confirm('Are you sure you want to delete? Deleted items cannot be recovered.！', 'Prompt', {
                        confirmButtonText: 'Confirm',
                        cancelButtonText: 'Cancel',
                        type: 'warning'
                        }).then(() => {
                            this.tableData[index]['delbtn_status_disabled'] = true
                            this.fetchdel('del', this.tableData[index]['keyword_id'], index)
                    });
            },
            handleCascader(value) {
                console.log('value', value)
            },
            showBatchBudgetModal(){
                this.$refs.batchBudgetModal.showModal();
            },
            // 删除  单个
            fetchdel(select_name, prop_id, sel_index) {
                // 单个请求中
                let flag_single_post_html = get_flag_single_post_html(prop_id)

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                let current_tip = this.$notify({
                    showClose: false,
                    duration: 0,
                    dangerouslyUseHTMLString: true,
                    message: flag_single_post_html
                });
                this.$store.commit('apple/ADD_NOTIFY',{
                    id: current_name,
                    value: current_tip,
                });
                this.tableData[sel_index]['delbtn_status_disabled'] = true
                let fetchparams = {keyword_id: [prop_id], current_name: current_name}
                this.axiosdel(fetchparams, current_name, select_name)
            },
            // fetch 删除
            axiosdel(fetchparams, old_current_name, select_name) {
                API.delNegativeKeyword(fetchparams).then(res=>{
                    let resultData = res.data

                    // 处理单个请求中 关闭
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    // let currency_time = new Date().valueOf()
                    // let current_name = `${select_name}_${currency_time}`
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 赋予表格状态
                    this.getListBody(this.props_params)
                },err => {
                    // 处理单个请求中 关闭
                    let resultData = err.data
                    let current_closed = this.$store.getters.apple_notify[old_current_name]
                    if(current_closed) {
                        current_closed.close()
                    }
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)
                    // 处理单个错误结果
                    let flag_single_err_html = get_flag_single_err_html(err['info'], resultData['msg'], mulErr, mulexc , old_current_name)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${old_current_name}_close`,
                        value: current_tip,
                    });
                    // 还原表格状态
                    let select_id = resultData['id']
                    let selectIndex = this.tableData.findIndex((element) => element['keyword_id'] == select_id)
                    if(selectIndex != -1) {
                        this.tableData[selectIndex]['delbtn_status_disabled'] = false
                    }
                })
            },
            // 删除 多个
            fetchdelmul(select_name, prop_id) {
                // 多个请求中
                this.dialogVisible = true
                this.dialogTypeTitle= 'Batch delete request successful, processing…'

                let currency_time = new Date().valueOf()
                let current_name = `${select_name}_${currency_time}`
                API.delNegativeKeyword({keyword_id: prop_id, current_name: current_name}).then(res=>{
                    let resultData = res.data

                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''

                    // 单个请求成功
                    let flag_single_post_html = get_flag_suc_html(res['info'], resultData['msg'])
                    this.$notify({
                        showClose: false,
                        duration: 5000,
                        dangerouslyUseHTMLString: true,
                        message: flag_single_post_html
                    });

                    // 成功赋予表格状态
                    this.getListBody(this.props_params)
                },err => {
                    let resultData = err.data
                    // 处理多个个请求中 关闭
                    this.dialogVisible = false
                    this.dialogTypeTitle= ''
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    let {errIds, mulErr, mulexc} = get_err_info(resultData.data)

                    // 处理多个错误结果
                    let flag_mul_err_html = get_flag_mul_err_html(err['info'], resultData['msg'], mulErr, mulexc , current_name, errIds, true)

                    let current_tip = this.$notify({
                        showClose: false,
                        duration: 0,
                        dangerouslyUseHTMLString: true,
                        message: flag_mul_err_html
                    })
                    this.$store.commit('apple/ADD_NOTIFY',{
                        id: `${current_name}_close`,
                        value: current_tip,
                    });
                    // 还原表格状态
                    this.getListBody(this.props_params)
                })
            },

            // 导出
            handleExport() {
                this.exportLoading = true;
                API.exportNegativeKeywordList(this.props_params,{
                    timeout: 120 * 1000,
                }).then(res => {
                    this.exportLoading = false;
                    console.log('res', res)
                    this.$message({
                        message: res.info,
                        type: 'success'
                    });
                }, (err) => {
                    this.exportLoading = false;
                    if(err.code =='403'){
                        this.$confirm(err.info, 'Prompt', {
                                confirmButtonText: 'Refresh',
                            cancelButtonText: 'Close',
                                type: 'warning',
                                showClose: false,
                                closeOnClickModal: false,
                                closeOnPressEscape: false
                                }).then(() => {
                                    window.location.reload()
                                }).catch(() => {});
                            return
                    }
                    this.$message.error(err.info||'Request Error');
                })
            },
            // 排序
            handlesortchange({column, prop, order}) {
                //ascending 升   descending 降
                console.log(column, prop, order)
                let order_type = order == 'ascending' ? 'asc' : 'desc'
                this.props_params['order_by'] = prop
                this.props_params['order_type'] = order_type
                this.getListBody(this.props_params)
            },
            // 排序显示
            getsortable(values, show) {
                if(values && values == 1 && other_Table_columns_no_sort.includes(show)) {
                    return 'custom'
                }
                return (values && values == 2) ? 'custom' : false
            },
            renderHeader(h, values, column) {
                let colName = column.name;
                let actionCol = this._findFieldByName(this.pageFields,colName)||{};
                let content_text = column['config'] && JSON.parse(column['config'])['title']
                let content_text1 = actionCol['config'] && JSON.parse(actionCol['config'])['title']
                let content_html = null
                if(column['field_type'] == 2) {
                    content_html = h(
                                    'el-tooltip',
                                        {
                                            props: {
                                            effect: 'dark',
                                            content: content_text1||content_text,
                                            placement: 'top',
                                            },
                                        },
                                        [
                                            h('i', {
                                            class: 'el-icon-question',
                                            style: 'margin-left:2px;'
                                            }),
                                        ]
                                    )
                }
                return h('div', {
                            style: 'display: inline-block;'
                        },
                [
                    h('div', {class: 'render-header-div'}, [
                        h('span', {
                                class: 'render-header-span'
                            }, values.column.label),
                        content_html
                    ])

                ])
            },
            // 分页 切换条数
            handleSizeChange(val) {
                this.props_params.rn = val
                this.props_params.pn = 1
                this.rn = val
                this.pn = 1
                this.getListBody(this.props_params)
            },
            // 分页 选择页数
            handleCurrentChange(val) {
                this.props_params.pn = val
                this.pn = val
                this.getListBody(this.props_params)
            },
            // 复制
            handlecopy() {
                let copyTxt = this.mulerrIds.join('\r\n');
                console.log('复制', copyTxt)
                utils.setClipboardText(copyTxt);
                this.$message({
                    message: 'Copied successfully',
                    type: 'success'
                });
                this.dialogVisible = false
            },
            searchList(){
                let routeParams = this.$route.params||{};
                let $query = this.$refs.query;
                console.log('searchList',routeParams,this.zone,this.rangeTime,$query.getQueryData());
            },
            getSearchList(){
                this.props_params.range_time = this.rangeTime;
                this.props_params.time_zone = this.zone;
                this.getListBody(this.props_params);
            },
            handleClickAdd(){
                console.log('handleClickAdd');
                this.addLoading = true;
                API.checkNegativeKeywordAddNegativeKeyword().then(()=>{
                    this.addLoading = false;
                    this.actionType = 'negativeKeywordAddNegativeKeyword';
                    this.$refs.negativeKeywordModal.showModal();
                },err=>{
                    this.addLoading = false;
                    this.$message.error(err.info||'Request failed');
                });
            },
            _findFieldByName(data, name) {
                for (let item in data) {
                    if (data[item].name == name) {
                        return data[item];
                    } else {
                        let child = data[item].children;
                        if (child && child.length > 0) {
                            let result = this._findFieldByName(child, name);
                            if (result) {
                                return result;
                            }
                        }
                    }
                }
            },
        }
    }
</script>

<style lang="scss" scoped>
    @import "~@/styles/apple_sd.scss";
    #operation-box ::v-deep{
        .apple-cascader.el-menu--horizontal{
            border-bottom: none;
            .el-submenu__title,.el-menu-item{
                font-size: 12px;
                border-bottom: none;
                padding: 0 15px!important;
            }
            &>.el-submenu .el-submenu__title{
                font-size: 12px;
                padding: 0 15px!important;
                color: #409eff;
                background: #ecf5ff;
                border: solid 1px #b3d8ff;
                height: 28px;
                line-height: 26px;
                border-radius: 3px;
                border-bottom-color: #b3d8ff!important;
                .el-submenu__icon-arrow{
                    color: #409eff;
                    display: inline-block!important;
                }
                &:hover{
                    background: #409eff;
                    border-color: #409eff;
                    color: #fff;
                    .el-submenu__icon-arrow{
                        color: #fff;
                    }
                }
            }

            .el-menu-item:hover{
                background-color:#ecf5ff;
            }
            .err-menu-item:hover{
                background-color:#fef0f0;
            }
        }
    }


.custom_input{
    .el-input__inner{
        padding: 0 8px;
    }
    .el-input-group__append{
        padding: 0 8px;
    }
}
</style>
<style lang="scss" scoped>
    .com-table-view-apple{
        background: #fff;
        /*padding: 10px 10px 10px;*/
        padding: 10px 0 10px;
        border-radius: 3px;
        border: 1px solid #e8eaec;
        margin-top: 10px;
        /*box-shadow: 0 1px 2px 0 rgba(0,0,0,.2);*/
        .operation-box{
            display: flex;
            justify-content:space-between;
            align-items: center;
            margin-bottom: 10px;
            padding: 0 15px;
            .operation-left{
                display: flex;
                justify-content:flex-start;
                align-items: center;
            }
        }
        .component_pagination{
            padding-top: 20px;
            padding-right: 20px;
            text-align: right;
        }
    }
    .custom_input{
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 3px;
        padding: 3px;
        .el-input-group__append{
            padding: 0 8px;
        }
        &.active{
            box-shadow: 0 1px 8px #bbb6b6;
        }
        .custom_input_el{
            margin-right: 4px;
            flex: auto;
        }
        .custom_input_btn{
            width: 48px;
            flex: 0 0 48px;
            display: flex;
            justify-content: space-evenly;
            align-items: center;
        }
        .custom_input_success{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border: 2px solid #67C23A;
            border-radius: 10px;
            background-color: #67C23A;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #9ed881;
                background-color: #9ed881;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
        .custom_input_close{
            width: 20px;
            height: 20px;
            line-height: 20px;
            border-radius: 10px;
            border: 2px solid #F56C6C;
            background-color: #F56C6C;
            text-align: center;
            cursor: pointer;
            &.btn-disabled{
                border: 2px solid #fe9999;
                background-color: #fe9999;
                cursor: no-drop;
            }
            i{
                color: #fff;
                font-weight: bold;
            }
        }
    }
    .table_operate{
        display: flex;
        justify-content: flex-start;
        align-items: center;
        span{
            cursor: pointer;
        }
    }
    .custom_drawer{
        padding: 0 8px;
        .title{
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e8eaec;
            padding: 8px 4px;
        }
        .drawer_list{
            padding: 8px 0;
            h4{
                font-size: 14px;
                margin-bottom: 8px;
            }
            .drawer_item{
                display:flex;
                align-items: center;
                padding: 4px 0;
                &>div{
                    &:first-child {
                        width: 100px;
                        flex: 0 0 100px;
                        padding-left: 16px;
                        color: #272727;
                    }
                    &:last-child {
                        flex: auto
                    }
                }
            }
        }
        .custom_input{
            align-items: flex-end;
            &.center{
                align-items: center;
            }
        }
    }
    .nodata{
        min-height: 300px;
    }

</style>


